import _classCallCheck from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { addUniqueItem, removeItem } from '../../utils/array.mjs';
import { compareByDepth } from './compare-by-depth.mjs';
var FlatTree = /*#__PURE__*/function () {
  function FlatTree() {
    _classCallCheck(this, FlatTree);
    this.children = [];
    this.isDirty = false;
  }
  _createClass(FlatTree, [{
    key: "add",
    value: function add(child) {
      addUniqueItem(this.children, child);
      this.isDirty = true;
    }
  }, {
    key: "remove",
    value: function remove(child) {
      removeItem(this.children, child);
      this.isDirty = true;
    }
  }, {
    key: "forEach",
    value: function forEach(callback) {
      this.isDirty && this.children.sort(compareByDepth);
      this.isDirty = false;
      this.children.forEach(callback);
    }
  }]);
  return FlatTree;
}();
export { FlatTree };